(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    const btn = event.target.closest('.product-card__size-item[data-variant-id]');
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    // Mark loading
    btn.setAttribute('aria-busy', 'true');

    // Collect section IDs — CartDrawer pushes its own ID into this array
    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('on_success', 'force_open_drawer');
    if (sectionsToBundle.length > 0) {
      formData.append('sections', sectionsToBundle.join(','));
      formData.append('sections_url', Shopify.routes.root + 'variants/' + variantId);
    }

    fetch(Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add.js ' + res.status);
        return res.json();
      })
      .then(function (addResponse) {
        return fetch(Shopify.routes.root + 'cart.js')
          .then(function (res) { return res.json(); })
          .then(function (cartData) {
            if (addResponse.sections) {
              cartData.sections = addResponse.sections;
            }
            // Triggers CartDrawer to refresh content and open
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: {
                baseEvent: 'variant:add',
                onSuccessDo: 'force_open_drawer',
                cart: cartData
              }
            }));
          });
      })
      .catch(function (err) {
        console.error('[MUARACHA] size overlay add to cart failed:', err);
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
      });
  });
})();
